import { jsx as _jsx } from "react/jsx-runtime";
import gemCategoryModelIcon from '../../../assets/new_gems/Category/GemCategoryModel.svg?inline';
export const GemCategoryModel = (props) => {
    return _jsx("img", { ...props, src: gemCategoryModelIcon, alt: 'GemCategoryModelImage' });
};
